import { render, staticRenderFns } from "./PostAssessment.vue?vue&type=template&id=a4795882&scoped=true"
import script from "./PostAssessment.vue?vue&type=script&lang=js"
export * from "./PostAssessment.vue?vue&type=script&lang=js"
import style0 from "./PostAssessment.vue?vue&type=style&index=0&id=a4795882&prod&scoped=true&lang=css"
import style1 from "./PostAssessment.vue?vue&type=style&index=1&id=a4795882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4795882",
  null
  
)

export default component.exports